export default "__VITE_ASSET__ac0ca621__"